import PropTypes from 'prop-types';
import React from 'react';
import Menu from '../../components/Menu/Menu';
import UserBlock from '../../components/UserBlock/UserBlock';
import { style } from '../Map/Layers/Assessment';

const classNames = require('classnames');
require('./Header.scss');

let misc = require('../../constants/Misc');
const endPoints = require('../../constants/EndPoints');

function Header(props, context) {
  const { user, selectedProject, local, lang, downloadFile, logo, onPathChange, signOutFunc, appContext } = props;
  //const defaultPath = './../../images/system/' + SYSTEM_RESOURCE + '/logo_left.png'
  const defaultLogo = require("../../../images/system/" + endPoints.SYSTEM_RESOURCE + "/logo_left.png");
  const panelClasses = classNames(
    'header',
    { 'custom': (process.env.REACT_APP_SYS_NAME === 'aqs' && logo != null) }
  );
  return (
    <header className={panelClasses}>

      <div className='header-icon'>
        <img
          src={require('../../../images/system/' + endPoints.SYSTEM_RESOURCE + '/header-bg-2.png')}
          width="60" height="60" />
        <div className="version">{context.t('version')} {misc.versionNumber}</div>
      </div>

      <UserBlock
        user={user}
        signOutFunc={signOutFunc}
        local={local}
        lang={lang}
        downloadFile={downloadFile}
        appContext={appContext}
      />


      <Menu
        selectedProject={selectedProject}
        onPathChange={onPathChange}
        user={user} />

      <div className="logo">
        <img src={logo || defaultLogo} width="198" height="70" />
      </div>

    </header>
  );
}

//   extends React.Component {
//   render() {
//     const { user, selectedProject, local, downloadFile, logo, onPathChange } = this.props;
//     //const defaultPath = './../../images/system/' + SYSTEM_RESOURCE + '/logo_left.png'
//     const defaultLogo = require("../../../images/system/" + endPoints.SYSTEM_RESOURCE + "/logo_left.png");
//     const panelClasses = classNames(
//       'header',
//       { 'custom': logo != null }
//     );
//     debugger;
//     return (
//       <header className={panelClasses}>

//         <div className="logo">
//           <img src={logo || defaultLogo} width="189" height="53"/>
//           <div className="version">{this.context.t('Version')} { misc.versionNumber }</div>
//         </div>

//         <UserBlock
//             user={user}
//             local={local}
//             downloadFile={downloadFile}/>

//         <Menu
//           selectedProject={selectedProject}
//           onPathChange={onPathChange}
//           user={user}/>

//       </header>
//     );
//   }
// }

Header.contextTypes = {
  t: PropTypes.func.isRequired
}

export default Header;
